import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';


// Utils
import propertyUtils from 'app/shared/utils/propertyUtils';

// Stylesheets
import './style.scss';

const propTypes = {
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    listingKey: PropTypes.string.isRequired,
    listing: PropTypes.object.isRequired,
    useAddress: PropTypes.bool,
};

const defaultProps = {
    onClick: undefined,
    useAddress: false,
};

const AddressColumn = ({
    index,
    onClick,
    listingKey,
    listing,
    useAddress,
}) => {
    const handleClick = (event) => {
        event.preventDefault();
        if (onClick) {
            onClick(listingKey);
        }
    };
    if (!listing) {
        return `Property #${index}`;
    }
    const { formattedName, formattedStreet, formattedCityState } = propertyUtils.formatAddress(listing);

    return (
        <div
            className={cx('AddressColumn', {
                'AddressColumn-clickable': onClick !== undefined,
            })}
            onClick={handleClick}
        >
            <Text type="h5" uppercase={true}>
                {useAddress ? formattedStreet : formattedName || formattedStreet}
            </Text>
            <Text>
                {formattedCityState}
            </Text>
        </div>
    );
};

AddressColumn.propTypes = propTypes;
AddressColumn.defaultProps = defaultProps;

export default AddressColumn;
